import { Component, OnInit, ViewChild, EventEmitter, Output, Input, ElementRef, Pipe } from '@angular/core';
import {NgbModal, ModalDismissReasons,} from '@ng-bootstrap/ng-bootstrap';
import { data } from 'jquery';
import {ActivatedRoute,Router} from '@angular/router';
import * as es6printJS from "print-js";
// src\app\services\utility-services
import { UtilityServiceService } from 'src/app/services/utility-services/utility-service.service';
import { FaqService } from '../../../services/faq-services/faq.service';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
// import { MatTableDataSource, MatPaginator, MatSort, PageEvent, MatTooltipModule } from '@angular/material';
import { FormControl, FormGroup ,FormArray, FormBuilder, Validators, Form, AbstractControl, ValidatorFn, NgForm, ValidationErrors } from '@angular/forms';
import {TooltipPosition} from '@angular/material/tooltip';
import { formatDate } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {jsPDF} from 'jspdf';
import { LocalStorageService } from 'src/app/services/localstorage-service/localstorage-service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { v4 as uuidv4 } from 'uuid';
import * as CryptoJS from 'crypto-js';
interface faqList {
  id?: number;
  title: string;
  faqid: number;
  category: string;
  description: string;
  articletitle:any;
  pdfurl:any;
  categories:[];
}
export interface User {
  response: string;
  message: string;
  allmessages: any[];
  sendMsg: string;
  query: string;
}
@Component
({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})

export class FaqComponent implements OnInit {
  @ViewChild('content') content: ElementRef;
  @Output() componentSelection = new EventEmitter<any>();

    // @Output() componentSelection = new EventEmitter < any > ();
    public isCollapsed = true;
    page = 1;
    pageSize = 5;
    data: any
    populararticles:faqList[];
    type: any;
    closeResult = '';
    public _opened: boolean = false;
    foundLocations: any;
    faqtitle: string;
    azid: any;
    dislikeForm: FormGroup;
    dislikeFormArray: FormArray;
    required = false;
    valueid: any;
    signUpForm: any;
    params: any;
    articles: any;
    populararticles2: any;
    filteredUsers: any;
    products = [];
    like;
    dislike;
    products1 = [];
    displayedColumns: string[] = ['ID', 'name'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    //categories=[];
    cardDetails: any;
    // dislikeReasons = [];
    a: any;
    classfive: any;
    classTen: any;
    CurrentPage: string;
    classtab: any;
    classname: any;
    tabs: any;
    char: [];
    faqsort: number;
    submitted = false;
    categories: any;
    keyword: string[];
    keywordheadtitle: any;
    activeClass: boolean = false;
    public selectedTab: any = 0;
    likePayload: any = {};
    dislikePayload: any = {};
    toggle=false;
    sendMailData: any = {};
    user;
    sendMailDataPayload: any = {};
    reason_array = [];
    public email_validate: boolean = false;
    fileName: string;
    emailFormData: FormGroup;
    emailFormSubmitted = false;
    togglehelp:boolean = false;
    // noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    toEmails: string = "";
    //emailContent: string = "New Maine SMART CHSTS Portal users must send an email to the respective Maine CDC contact for new user registration.\n\nFor questions about newborn bloodspot, contact Anne Watson. Email: anne.watson@maine.gov, Ph: (207) 287-8188 \nFor questions about newborn hearing and/or audiology, contact Anne Banger. Email: anne.banger@maine.gov, Ph: (207)287-8427\nFor questions about birth defects, contact Anna Cyr. Email: anna.cyr@maine.gov, Ph: (207) 287-8424\n\nAfter the user has been restored within the portal, you will receive an email from support.mainechsts@nebulogic.com with login credentials and password reset information.\n";
    emailContent: string = "";
    myDate = new Date();
    mutlipleemail:boolean=false;
    emailtexttoggle:boolean=false;

    @ViewChild('dataContainer') dataContainer: ElementRef;
    @ViewChild('pdfViewerFaq') public pdfViewerFaq;
    selectedItems: any;
    check_data: boolean = false;
    recently: boolean = false;
    @Input() selectionType='faq';


    public start:number=65;
    public end:number=91;
    tableId: string;
    aiuser: User = {
      message: "",
      allmessages: [],
      sendMsg: "",
      response: "",
      query: "",
  };
  conversationId: string;
    constructor(private modalService: NgbModal,
        private router: Router,
        private http: HttpClient,
        private faqService: FaqService,
        private formBuilder: FormBuilder,
        private utilityService: UtilityServiceService,
        private localStorageService: LocalStorageService,
        private sanitizer: DomSanitizer,
    ) {
        this.azid = localStorage.getItem("filter") == "A-Z"
        this.tabs = JSON.parse(localStorage.getItem('addtab'));
        console.log("tabsss",this.tabs)
        this.classtab = localStorage.getItem("classtable")
        this.faqtitle = localStorage.getItem("filter");
        this.conversationId = this.generateUniqueID();
    }
    generateUniqueID() {
      return uuidv4();
  }
  loading = false;
  isMaxLengthExceeded = false;

    checkMaxLength() {
      this.isMaxLengthExceeded = this.aiuser.sendMsg.length > 250;
    }


    OnSubmit(form: NgForm) {

      if(this.aiuser.sendMsg!='')
      {
        // return false;

        $(".chat-body").animate({ scrollTop: $('.chat-body').prop("scrollHeight") }, 1000);
        console.log(this.aiuser);
        const currentTime:any = new Date().getTime();
        const expiresIn:any = currentTime + (30 * 1000);
        var header = {
            "alg": "HS256",
            "typ": "JWT"
        };

        // var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
        // var encodedHeader = this.base64url(stringifiedHeader);
        const encodedHeader = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(JSON.stringify(header)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');

        var data = {
            // "query": this.user.sendMsg,
            "conversation_id": this.conversationId,
            "knowledge": "agent-knowledge",
            "exp": parseInt((expiresIn / 1000).toString()),
            "iat":parseInt((currentTime/1000).toString()),
            // "iss":'Customer portal'
        };
        const encodedData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(JSON.stringify(data)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');

// Create JWT token
const token = `${encodedHeader}.${encodedData}`;
const secret = "cqLfvq3KRTmP5vE8f2SdHyiKViPTx0L0";
const signature = CryptoJS.HmacSHA256(token, secret);
const encodedSignature = CryptoJS.enc.Base64.stringify(signature)
           .replace(/\+/g, '-')
           .replace(/\//g, '_')
           .replace(/=+$/, '');

const signedToken = `${token}.${encodedSignature}`;
console.log("token", signedToken);

const payLoad = {
"query": signedToken
};
console.log(payLoad);
const userMessage = {
  query: this.aiuser.sendMsg,
  response: '<img src="../assets/images/writing-loading.gif" width="50px" height="25px">'
};
        this.loading = true;
        this.aiuser.response = "";

          this.faqService.sendMessage(signedToken,{ query: userMessage.query}).subscribe((res: any) => {
            this.loading = false;

            res.timestamp = new Date().getTime();
            console.log("Response from chatbot:", res);
            var airesponse=res.response;
            console.log(airesponse);
            // const updatedResponse = airesponse.replace(
            //   /\[([^\]]+)\]\((http[s]?:\/\/[^\)]+)\)/g,
            // '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
            //       );
                  //  this.sanitizer.bypassSecurityTrustHtml(updatedResponse);
            const updatedResponse = airesponse.replace(
              /\[([^\]]+)\]\((http[s]?:\/\/[^\)]+)\)/g,
              (match, text, url) =>
                  `<a href="${url}" target="_blank" rel="noopener noreferrer" class="clickable-link">${text}</a>`
          );
                   this.sanitizer.bypassSecurityTrustHtml(updatedResponse);

            this.aiuser.response = updatedResponse;
            setTimeout(() => {
              document.querySelectorAll('.clickable-link').forEach(link => {
                link.addEventListener('click', (event) => this.handleLinkClick(event));
            });
                $(".chat-body").animate({ scrollTop: $('.chat-body').prop("scrollHeight") }, 1000);
            }, 200)
        })

      }
    }
     component:any

     handleLinkClick(event: Event) {
      const target = event.target as HTMLAnchorElement;

      // Check if the target has an `href` and it matches the desired URL pattern
      if (target.href && target.href.includes("https://fortwayne-portal.thesmartcity311.com/answers/details/")) {
        const linkUrl = target.href; // Get the link URL
        const linkText = target.innerText;
        const extractedText = linkText.split(' - ')[0]; // Split by " - " and take the first part
        console.log(extractedText);

        const lastSegment = linkUrl.split('/').pop();
        this.faqService.answerid = lastSegment;
        this.componentSelection.emit({ 'id': `${linkUrl}`, 'name': extractedText, 'type': 'aikb',src:'../../assets/images/knowledgeBase.svg' });
        event.preventDefault(); // Prevent the default link behavior

        console.log(`Handled link: ${linkUrl}`);
      } else {
        console.log("Link does not match the desired URL pattern.");
      }
    }

    base64url(source: any) {
        let encodedSource = CryptoJS.enc.Base64.stringify(source);
        encodedSource = encodedSource.replace(/=+$/, '');
        encodedSource = encodedSource.replace(/\+/g, '-');
        encodedSource = encodedSource.replace(/\//g, '_');
        return encodedSource;
    }
    isAdvancedSearchActive: boolean = false;
  checked:boolean=false;

  showTable:boolean=false;
    toggleAdvanceSearch(checked: boolean) {
      console.log(checked)
      if (!checked) {
        this.faqtitle = localStorage.getItem("filter") || 'All';
        // alert(this.faqtitle)
        if(this.faqtitle=='Search Results')
        {
          this.faqtitle='All';
        }
        this.aiuser.sendMsg = '';
        this.aiuser.response = '';
        this.datatablepagination();
      }
      else {
        this.faqtitle = ''; // Clear the filter when toggling AI Search on
      }
      this.isAdvancedSearchActive = this.checked;
      if (!this.isAdvancedSearchActive) {
        // this.faqtitle = localStorage.getItem("filter");
        this.showTable = false;
       // Hide table when isAdvancedSearchActive is false
      }else{
        this.showTable=true;
      }
    }
    keywordActive(event, newValue) {
        this.selectedItems = newValue;
        $("#mat-tab-label-0-0").trigger("click");
    }
    truncateContent(content: string): string {
      const words = content.split(' ');
      if (words.length > 100) {
          return words.slice(0, 100).join(' ') + '...'; // Add ellipsis after 100 words
      } else {
          return content;
      }
  }
  stripHtmlAndEntities1(htmlString: string, keyword: string): string {

    if (!htmlString) return '';

    // Remove HTML tags
    const withoutTags = htmlString.replace(/<[^>]*>/g, '');

    // Remove &nbsp; entities
    const withoutEntities = withoutTags.replace(/&nbsp;/g, ' ');

    // Split content into words
    const words = withoutEntities.split(' ');

    // Check if keyword is present in any of the words
    const result = words.map(word => {
        if (word.toLowerCase().includes(keyword.toLowerCase())&& keyword!='') {
            return `<strong style="color: yellow;">${word}</strong>`;
        } else {
            return word;
        }
    }).join(' ');

    return result;
}



  stripHtmlAndEntities(htmlString: string): string {
    if (!htmlString) return '';

    // Remove HTML tags
    const withoutTags = htmlString.replace(/<[^>]*>/g, '');
    const trimmedString = withoutTags.trim().replace(/^"/, '').replace(/"$/, '');
    // Remove &nbsp; entities
    const withoutEntities = trimmedString.replace(/&nbsp;/g, ' ');

    // Remove quotation marks
    const withoutQuotationMarks = withoutEntities.replace(/"/g, '');

    // Split content into words
    const words = withoutQuotationMarks.split(' ');

    // Check if content exceeds 100 words
    if (words.length > 100) {
      return words.slice(0, 100).join(' ') + '...'; // Add ellipsis after 100 words
    } else {
      return withoutQuotationMarks;
    }
  }

  stripemailHtmlAndEntities(htmlString: string): string {
    if (!htmlString) return '';

    // Remove HTML tags
    const withoutTags = htmlString.replace(/<[^>]*>/g, '');
    const trimmedString = withoutTags.trim().replace(/^"/, '').replace(/"$/, '');
    // Remove &nbsp; entities
    const withoutEntities = trimmedString.replace(/&nbsp;/g, ' ');

    // Remove quotation marks
    const withoutQuotationMarks = withoutEntities.replace(/"/g, '');

    // Split content into words
    const words = withoutQuotationMarks.split(' ');
    return withoutQuotationMarks;

  }

  pages:any;
  size=['10','25','50','100'];
  // currentPage: number = 0;
  faqpageSize: number = 10;
  totalpagesize:any;
  totalItems: number = 50;
  answerlistlength:any;
  allfaq:any=[];
  currentPage:number=0;
  loadFAQs(): void {
    // this.pageSize=this.basicpagesize
    // this.showTable = !this.isAdvancedSearchActive;
    this.datatableload=false;
    console.log(this.currentPage)
    console.log(this.faqpageSize)
    this.faqService.allArticles(this.currentPage,this.faqpageSize)
      .subscribe((data: any) => {
        console.log(data);
        this.allfaq = data.answerlist;
        console.log(this.allfaq)
  this.answerlistlength=data.answerlist.length;
        this.totalpagesize=data.size;
        console.log(this.allfaq);
        this.datatablepagination()
      });
      // this.showTable = !this.isAdvancedSearchActive;
  }
  getallpopularanswers():void{
    // this.pageSize=this.basicpagesize
console.log(this.currentPage)
console.log(this.faqpageSize)
this.datatableload=false;
    this.faqService.popularArticles(this.currentPage,this.faqpageSize).subscribe((data) => {
      console.log(data)
        this.allfaq = data.answerlist;
        this.answerlistlength=data.answerlist.length;
        this.totalpagesize=data.size;
        console.log(this.allfaq)
        this.datatablepagination()
        // this.dataSource.data = this.populararticles;
        // if(this.dataSource.data.length>=0){
        //     this.check_data=true;

        // }
    });
  }
  onpagesize(pagesize:any)
  {
    console.log(pagesize)
    console.log(this.local_filter)
    this.faqpageSize=pagesize;
    this.getPageNumbers()
    if(this.local_filter == "Popular")
    {
      this.getallpopularanswers()

    }

    if (this.local_filter == "All"||this.local_filter == "A-Z")
    {
      this.loadFAQs()
    }
    if(this.local_filter=="keyword")
    {
      console.log("inf ")
      console.log(this.keywords)
      this.getArticlesByKeyword(this.keywords)
    }
    if(this.local_filter=="Recent")
    {
      this.getrecentfaq();
    }
    if(this.local_filter=="Search Results")
    {
      this.onChangeSearch(this.searchtermsinput);
    }



    // if(this.searchterms=='')
    // {
    //   console.log("search query in loadfaq",this.searchterms)

    //   // this.goToPage(this.currentPage)
    //   this.getPageNumbers()
    //   this.loadFAQs();

    //   console.log(this.currentPage)
    //   console.log(this.pageCount)
    //   // this.getPageNumbers();
    // }

  //   console.log(this.searchterms)
  //   if(this.searchterms!='')
  //   {
  //     console.log("search query in onsearch",this.searchterms)
  //     this.getPageNumbers()
  // this.onSearch1(this.searchterms,false)
  //   }
  }
  nextPage2(): void {
    console.log(this.searchterms)
    this.currentPage++;
    console.log(this.local_filter)

    if(this.local_filter == "Popular")
    {
      console.log(" first inf ")
      this.getallpopularanswers()

    }

    if (this.local_filter == "All"||this.local_filter == "A-Z")
    {
      console.log(" second inf ")
      this.loadFAQs()
    }
    if(this.local_filter=="keyword")
    {
      console.log("inf ")
      console.log(this.keywords)
      this.getArticlesByKeyword(this.keywords)
    }
    if(this.local_filter=="Recent")
    {
      this.getrecentfaq();
    }
    if(this.local_filter=="Search Results"  && this.searchterms!='')
    {
      this.initialPageResetDone="next";

      this.onChangeSearch(this.searchtermsinput);
    }
      if(this.local_filter=="Search Results" && this.searchterms=='')
        {
          this.loadFAQs();
        }
    // if(this.searchterms=='')
    // {
    //   console.log("search query in loadfaq",this.searchterms)
    //   this.loadFAQs();
    // }

  //   console.log(this.searchterms)
  //   if(this.searchterms!='')
  //   {
  //     this.initialPageResetDone="next";
  //     console.log("search query in onsearch",this.searchterms)
  // this.onSearch1(this.searchterms,false)
  //   }
  }

  previousPage2(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      if(this.local_filter == "Popular")
      {
        this.getallpopularanswers()

      }

      if (this.local_filter == "All"||this.local_filter == "A-Z")
      {
        this.loadFAQs()
      }
      if(this.local_filter=="keyword")
      {
        console.log("inf ")
      console.log(this.keywords)
        this.getArticlesByKeyword(this.keywords)
      }
      if(this.local_filter=="Recent")
      {
        this.getrecentfaq();
      }
      if(this.local_filter=="Search Results" && this.searchterms!='')
      {
        this.onChangeSearch(this.searchtermsinput);
      }
        if(this.local_filter=="Search Results" && this.searchterms=='')
          {
            this.loadFAQs();
          }

      // if(this.searchterms=='')
      // {
      //   console.log("search query in loadfaq",this.searchterms)
      //   this.loadFAQs();
      // }
    //   if(this.searchterms!='')
    //   {
    //     console.log("search query in onsearch",this.searchterms)
    // this.onSearch1(this.searchterms,false)
    //   }
    }
  }
  pageCount:any;

  getPageNumbers(): number[] {
// console.log(this.searchtermsinput)
    if(this.searchtermsinput!='')
    {
      // console.log("hellooooooo")
      this.initialPageResetDone="next";

    }
    // this.loadFAQs();
    const pageCount = Math.ceil(this.totalpagesize / this.faqpageSize);
    this.pageCount = pageCount;
    const pageNumbers = [];
    let currentPageIndex = this.currentPage;

    // Show first 5 page numbers initially
    let startPage = Math.max(0, currentPageIndex - 2);
    const endPage = Math.min(pageCount - 1, startPage + 4);
  // console.log("startpage",startPage)
  // console.log("endpage",endPage)
  // console.log("pageCount",pageCount)
  // console.log("currentPageIndex",currentPageIndex)
    // Adjust startPage and endPage when total items are less than expected end page
    if (endPage - startPage < 4 && endPage < pageCount - 1) {
      startPage = Math.max(0, endPage - 4);
    }
  if(this.currentPage>endPage)
  {
    this.currentPage=endPage;
    console.log(this.currentPage)
    // this.loadFAQs()

  }
//   if(this.searchterms!='')
//   {
//     this.initialPageResetDone="next";
//     console.log("search query in onsearch",this.searchterms)
// // this.onSearch1(this.searchterms)
//   }
    for (let i = startPage; i <= endPage; i++) {
  // console.log(pageNumbers)
      pageNumbers.push(i);
    }

    return pageNumbers;
  }


  goToPage(pageNumber: number): void {
    this.currentPage = pageNumber;
    console.log(this.currentPage)
    console.log(this.local_filter)
    if(this.local_filter == "Popular")
    {
      this.getallpopularanswers()

    }

    if (this.local_filter == "All"|| this.local_filter == "A-Z")
    {
      this.loadFAQs()
    }
    if(this.local_filter=="keyword")
    {
      console.log("inf ")
      console.log(this.keywords)
      this.getArticlesByKeyword(this.keywords)
    }
    if(this.local_filter=="Recent")
    {
      this.getrecentfaq();
    }
    if(this.local_filter=="Search Results" && this.searchterms!='')
    {
      this.onChangeSearch(this.searchtermsinput);
    }
    if(this.local_filter=="Search Results" && this.searchterms=='')
      {
        this.loadFAQs();
      }

    // if(this.searchterms=='')
    // {
    //   console.log("search query in loadfaq",this.searchterms)
    //   this.loadFAQs();
    // }

    // console.log(this.searchterms)
  //   if(this.searchterms!='')
  //   {
  //     // this.initialPageResetDone="next";
  //     console.log("search query in onsearch",this.searchterms)
  // this.onSearch1(this.searchterms,false)
  //   }
  }
  getRecordsRange(): string {
    const startRecord = this.currentPage * this.faqpageSize + 1;
    // console.log(startRecord)
    const endRecord = Math.min((this.currentPage + 1) * this.faqpageSize, this.totalpagesize);
    // console.log(endRecord)

    return `${startRecord} - ${endRecord} of ${this.totalpagesize}`;
  }
  tcontainer = {
    height: (($(window).height() - $('.layout-navbar').height()) - 375) + 'px'
  };
  tcontainer1 = {
    height: (($(window).height() - $('.layout-navbar').height()) - 450) + 'px',
   overflow:scroll
  };

  datatablepagination() {
    // alert()
        $("#faqdatatable_wrapper").remove();

        setTimeout(() => {
          ($('#faqdatatable') as any).dataTable({
            "language": {
              "paginate": {
                "previous": "",
                "next": ""
              },
              "lengthMenu": "Records per page _MENU_",
            },
            pageLength: this.faqpageSize,
            // "order": [[2, "asc"]],

            "columnDefs": [
              { "orderable": false, "targets": 0 },
              { "orderable": false, "targets": 5 },

            ],


            fixedColumns: {
                start: 0,
                end: 1
            },

            "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],

            paging: true,
            fixedHeader: true,
             scrollX: true,
             scrollY:this.tcontainer.height,
            destroy:true,
            dom: 'frt',

            drawCallback: function (settings) {
              const api = this.api();
              const rows = api.rows({ page: 'current' }).nodes();
              let startIndex = api.page() * api.page.len() + 1;

              $(rows).each(function (index) {
                $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
                startIndex++;
              });
            },
          });
        }, 200);

        this.datatableload=true

      }
      datatableload:any
    public keytabs = [];
    @Input() clearsearchText;
    ngOnChanges() {
        this.tabs = [] || JSON.parse(localStorage.getItem('addtab'));
        if(this.clearsearchText != undefined && this.clearsearchText.clear == true) {
          this.faqForm.patchValue({
              name:""
          });
          this.clearsearchText.clear = false;
      }
    }
    selected = new FormControl(0);

    close(pop:any)
    {
        pop.close()
    }
    // add selected articles to tab
    addTab(aid, id, title) {
        var a = [];
        a = JSON.parse(localStorage.getItem('addtab')) || [];
        var checkidexists = a.findIndex(article => article.id == id);
        var tab_count=parseInt(localStorage.getItem('selectedTab')) || 1;
        tab_count+=1;
        localStorage.setItem('selectedTab',JSON.stringify(tab_count));
        this.selectedTab=tab_count;
        // console.log("selectedTab "+this.selectedTab);
        if (checkidexists == -1) {
            if (this.tabs.length <= 4) {
                a.push({
                    articleid: aid,
                    id: id,
                    articletitle: title
                });
                this.tabs.push({
                    articleid: aid,
                    id: id,
                    articletitle: title
                });
            } else {
                this.tabs.splice(0, 1);
                this.tabs.push({
                    articleid: aid,
                    id: id,
                    articletitle: title
                });
                a.splice(0, 1);
                a.push({
                    articleid: aid,
                    id: id,
                    articletitle: title
                });
            }

        }
        if (checkidexists >= 0) {
            this.tabs.splice(checkidexists, 1);
            this.tabs.push({
                articleid: aid,
                id: id,
                articletitle: title
            });
            a.splice(checkidexists, 1);
            a.push({
                articleid: aid,
                id: id,
                articletitle: title
            });
        }
        // if(this.selectionType == 'faq')
            localStorage.setItem('addtab', JSON.stringify(a));
    }

    //remove tab
    removeTab(index: any) {
      console.log(index)
        this.tabs.splice(index, 1);
        this.a = JSON.parse(localStorage.getItem('addtab'));
        this.a.splice(index, 1);
        localStorage.setItem('addtab', JSON.stringify(this.tabs));
        var new_index = index - 1;
        console.log(new_index)
        this.getDetailsByArticleID(this.a[new_index].id);
        this.selectedTab = new_index + 1;
        console.log(this.selectedTab)
    }

    open(content) {
        this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title'
        }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: $ {
                      reason
                  }`;
        }
    }
    tab: any;
    faqForm: FormGroup;
    getpopular() {
            this.checked=false;
this.toggleAdvanceSearch(false);
      this.isAdvancedSearchActive=false;
      this.tabs=[];
         this.aiuser.sendMsg = '';
        this.aiuser.response = '';
      this.suggestionvalues=[];
      this.keywordheadtitle="";
      this.searchtermsinput='';
      // console.log(this.tabs)
      // this.removeTab(this.tabs.length-1)
      this.getSelectedDetails();
      localStorage.removeItem("addtab");
      this.azid = false;
      this.faqtitle='Popular'

      $("#popular").prop('checked', true);
      localStorage.setItem("filter", "Popular");
      localStorage.removeItem("keyword");
      this.getallpopularanswers();
      // this.oncomponentSelection({
      //   id: 'faq',
      //   name: 'FAQ',
      //   type: 'faq'
      // });
      this.tab = [] || JSON.parse(localStorage.getItem('addtab'));
      this.faqForm.patchValue({
        name: ""
      });
    }
    onkey() {
            this.checked=false;
this.toggleAdvanceSearch(false);
      this.isAdvancedSearchActive=false;
      this.tabs=[];
         this.aiuser.sendMsg = '';
        this.aiuser.response = '';
      this.suggestionvalues=[];
      this.keywordheadtitle="";
      this.azid = false;
      this.faqtitle='Recently Viewed'
this.searchtermsinput='';
      localStorage.setItem("filter", "Recent");
      localStorage.removeItem("keyword");
      localStorage.removeItem("addtab");
      this.getrecentfaq();
      this.tab = [] || JSON.parse(localStorage.getItem('addtab'));
      // this.oncomponentSelection({
      //   id: 'faq',
      //   name: 'FAQ',
      //   type: 'faq'
      // });
      this.faqForm.patchValue({
        name: ""
      });
      $("#all").prop('checked', false);
      $("#atoz").prop('checked', false);
      $("#popular").prop('checked', false);
    }
    getaz() {
            this.checked=false;
this.toggleAdvanceSearch(false);
      this.isAdvancedSearchActive=false;
      this.tabs=[];
      this.suggestionvalues=[];
   this.aiuser.sendMsg = '';
        this.aiuser.response = '';
      this.faqtitle='A-Z'
this.searchtermsinput='';
      this.azid = true;
      localStorage.removeItem("addtab");
      this.faqService.getAtoZCount().subscribe(data => {
        this.utilityService.setAtoZCount(data);
      });
      console.log(this.azid)
      if(this.azid) {
        console.log(this.azid)
        this.createSequence(data);
         this.utilityService.getAtoZCount().subscribe(data => {
          console.log(data)
           if(JSON.stringify(data) != "{}") {
                this.createSequence(data);
          }
        });
    }
      localStorage.setItem("filter", "A-Z");
      localStorage.removeItem("keyword");
      this.loadFAQs();

      this.tab = [] || localStorage.getItem('addtab');
      // this.oncomponentSelection({
      //   id: 'faq',
      //   name: 'FAQ',
      //   type: 'faq'
      // });
      this.faqForm.patchValue({
        name: ""
      });
    }
    get name() {
      return this.faqForm.controls['name'];
    }
    getall() {
      this.tabs=[];
      this.checked=false;
// this.toggleAdvanceSearch(false);
      this.isAdvancedSearchActive=false;
         this.aiuser.sendMsg = '';
        this.aiuser.response = '';
      this.showTable = !this.isAdvancedSearchActive;
      console.log(this.showTable)
      this.suggestionvalues=[];
      this.keywordheadtitle="";
      this.azid = false;
      this.faqtitle='All'
// this.isAdvancedSearchActive=false;
      localStorage.removeItem("addtab");
      localStorage.setItem("filter", "All");
      localStorage.removeItem("keyword");
      this.loadFAQs();
      this.tab = [] || JSON.parse(localStorage.getItem('addtab'));
      // this.oncomponentSelection({
      //   id: 'faq',
      //   name: 'FAQ',
      //   type: 'faq'
      // });
      this.faqForm.patchValue({
        name: ""
      });
    }
keywords:any;
    //Filter By Keyword
    getArticlesByKeyword(ktab) {
console.log(ktab)
this.keywords=ktab;
console.log(this.keywords)
       localStorage.setItem("keyword", ktab.keywords);
       this.local_filter="keyword";
console.log(this.local_filter)
this.datatableload=false;
        this.activeClass = !this.activeClass;
        this.faqService.getArticlesByKeywords(ktab.keywords,this.currentPage,this.faqpageSize).subscribe((data) => {
          console.log(data)
          this.allfaq = data.answerlist;
          console.log(this.allfaq)
          // console.log(this.allfaq.answeridobject.description)
          this.answerlistlength=data.answerlist.length;
                this.totalpagesize=data.size;
                console.log(this.totalpagesize)
            // this.dataSource.data = this.populararticles;
            this.keywordheadtitle = localStorage.getItem('keyword');
            this.datatablepagination()
        });
    }

    ngAfterViewInit() {
        console.log('selectionType ', this.selectionType);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }
    clearFormArray = (formArray: FormArray) => {
        while (formArray.length !== 0) {
          formArray.removeAt(0)
        }
    }
answerbyid:any;
username:any;
likestatus:any;
   getDetailsByArticleID(id: number) {
       this.required = true;
        this.faqService.article(id).subscribe(
            (article:any) => {
                this.like=false;
                this.dislike = false;
                this.answerbyid=article;
                this.likestatus=article;
                console.log(this.answerbyid)
                this.cardDetails = article.answerlist[0];

                // console.log(this.cardDetails[0].answeridobject.description)
                if(this.selectionType == 'help' || this.selectionType == 'training') {
                    if(this.togglehelp == false) {
                        this.togglehelp = true;
                        this.addTab(this.cardDetails.answerid, this.cardDetails.id, this.cardDetails.answeridobject.description);
                    }
                }
                this.emailContent=this.cardDetails.answeridobject.solution;
                this.stripHtmlAndEntities(this.emailContent);
                this.username=JSON.parse(this.localStorageService.get('currentUser')).email;
                console.log(this.username)

                this.emailFormData.patchValue({
                    toaddr: this.username,
                    emailmsg: this.stripHtmlAndEntities(this.emailContent)
                });

                // console.log('options ', this.cardDetails.likeStatus.options);
                console.log(this.cardDetails);
                // this.downloadFile(article.pdfurl.toString().trim()).subscribe(
                //   (res) => {
                //     this.pdfViewerFaq.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
                //     this.pdfViewerFaq.refresh();
                //   }
                // );
                if(this.answerbyid.likestatus) {
                  this.reasonArray();
                  this.clearFormArray(this.dislikeFormArray);
                  for(let i in this.answerbyid.likestatus.options) {
                      this.required = false;
                      this.reason_array[this.answerbyid.likestatus.options[i]-1].checked = true;
                      this.dislikeFormArray.push(new FormControl(this.answerbyid.likestatus.options[i]));
                  }
                  if(this.answerbyid.likestatus.flike) {
                      this.like=true;
                      this.dislike = false;
                  } else {
                      this.dislike=true;
                      this.like = false;
                  }
              }
                //   if(article.likestatus) {
                //     console.log("hy")
                //     this.reasonArray();
                //     this.clearFormArray(this.dislikeFormArray);
                //     // for(article.likeStatus.flike) {
                //     //     this.required = false;
                //     //     this.reason_array[this.cardDetails.likeStatus.options[i]-1].checked = true;
                //     //     this.dislikeFormArray.push(new FormControl(this.cardDetails.likeStatus.options[i]));
                //     // }
                //     if(article.likestatus.flike) {
                //         this.like=true;
                //         this.dislike = false;
                //     } else {
                //         this.dislike=true;
                //         this.like = false;
                //     }
                // }
            }
        )
    }

    private downloadFile(url: string): any {
        return this.http.get(url, { responseType: 'blob' })
        .pipe(
            map((result: any) => {
                return result;
            })
        );
    }

    ChangeScreen(button: string) {
        this.CurrentPage = button;
    }

    getServerData() {
        if (this.dataSource.paginator.pageSize == 5) {
            this.classname = "clicked5";
            $(".cdk-overlay-container").addClass("clicked5class");
        }
        if (this.dataSource.paginator.pageSize == 10) {
            this.classname = "clicked10";
            $(".cdk-overlay-container").removeClass("clicked5class");
        }
        if (this.dataSource.paginator.pageSize == 15) {
            this.classname = "clicked15";
            $(".cdk-overlay-container").removeClass("clicked5class");
        }
    }
    getSelectedDetails() {

        if (localStorage.getItem("currentTab") != null) {
            var currentTab = localStorage.getItem("currentTab");
            var tab = JSON.parse(localStorage.getItem('addtab')) || [];
            this.selectedTab = tab.length + 1;
            this.getDetailsByArticleID(parseInt(currentTab));
            localStorage.removeItem("currentTab");
        } else {
            this.selectedTab = 0;
            localStorage.removeItem("currentTab");
        }
    }
    // public componentSelectionEmitter(componentData: any) {
    //     this.selectedItem = componentData.type;
    //     this.componentSelection.emit(componentData);
    //     // console.log(componentData);
    // }

    commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
        const emails = control.value.split(',');
        const forbidden = emails.some(email => Validators.email(new FormControl(email)));
        //console.log(forbidden);
        if(forbidden==true)
        {
            this.mutlipleemail=true;
            //console.log(this.mutlipleemail);
        }
        else{
            this.mutlipleemail=false;

        }
        return forbidden ? { 'toaddr': { value: control.value } } : null;
      };
      dataSource:any;
      noData:any;
      alldata:any;
      tcontainerbody = {
        height:(($(window).height() - $('.layout-navbar').height()) - 350) + 'px'
      };
      local_filter:any;
      searchterms:any;
      // basicpagesize=10
      getrecentfaq()
      {
        // this.pageSize=this.basicpagesize
        this.datatableload=false
        this.faqService.getRecentArticles().subscribe((data) => {
          this.allfaq = data.answerlist;
          this.datatablepagination()
          this.answerlistlength=data.answerlist.length;
          this.totalpagesize=data.size;
          // console.log(this.allfaq.answeridobject.description)
          // this.dataSource.data = this.populararticles;
          // if(this.dataSource.data.length>=0){
          //     this.check_data=true;
          //     this.recently=true;
          // }
      });
      }

      selectEvent($event) {
        this.suggestionvalues=[];
        console.log($event)
        var a = [];
        a = JSON.parse(localStorage.getItem('addtab')) || [];
        var checkidexists = a.findIndex(article => article.id == $event.id);
        var tab_count=parseInt(localStorage.getItem('selectedTab')) || 1;
        tab_count+=1;
        localStorage.setItem('selectedTab',JSON.stringify(tab_count));
        this.selectedTab=tab_count;
        if (checkidexists == -1) {
            if (a.length <= 4) {
                a.push({
                    articleid: $event.id,
                    id: $event.id,
                    articletitle: $event.description
                });
                this.tabs.push({
                  articleid: $event.id,
                  id: $event.id,
                  articletitle: $event.description
                });
            } else {
                this.tabs.splice(0, 1);
                this.tabs.push({
                  articleid: $event.id,
                    id: $event.id,
                    articletitle: $event.description
                });
                a.splice(0, 1);
                a.push({
                  articleid: $event.id,
                  id: $event.id,
                  articletitle: $event.description
                });
            }
            localStorage.setItem("currentTab", $event.id);
            this.getDetailsByArticleID($event.id)
        }

        if (checkidexists >= 0) {
            this.tabs.splice(checkidexists, 1);
            this.tabs.push({
              articleid: $event.id,
              id: $event.id,
              articletitle: $event.description
            });
            a.splice(checkidexists, 1);
            a.push({
              articleid: $event.id,
                    id: $event.id,
                    articletitle: $event.description
            });
            this.selectedTab = checkidexists + 1;
            localStorage.setItem("currentTab", $event.id);
        }
        this.utilityService.setSearch(true);
        localStorage.setItem('addtab', JSON.stringify(a));
        // this.componentSelectionEmitter({
        //     id: 'faq',
        //     name: 'FAQ',
        //     type: 'faq'
        // });
        // console.log("tabs:");
        // console.log(this.tabs);
        // console.log("a:");
        // console.log(a);
    }
    onFocusSearch(e){
      console.log(e);
      this.loadFAQs();
      // this.faqService.allArticles().subscribe(data=>{
      //     this.suggestionvalues=data;
      // })
  }
  searchtermsinput:any=''
  clearsearch()
  {
    this.searchtermsinput='';
    this.suggestionvalues='';
    $('.pane:visible .dt-search input').val(this.searchtermsinput).keyup();

  }
  initialPageResetDone= "search";
  onChangeSearch(query: string,resetPage: boolean = true) {
    // $('.pane:visible .dt-search input').val(query).keyup();
console.log(this.tabs)
    this.faqService.previousserchkeyword=this.searchterms;
    console.log(this.faqService.previousserchkeyword)
    // this.faqtitle='Search Results';
    this.faqtitle='All';
    this.azid=false;
    localStorage.setItem('filter', "Search Results");
    this.local_filter='Search Results';
    console.log(query)
    console.log(this.currentPage)
      // this.searchPerformed = true; // Set the flag to true to indicate that a search has been performed
      const searchResults: any[] = [];
      this.searchterms = query;
    //   if (resetPage) {
    //     this.currentPage = 0; // Reset the current page to 0 only if it's a new search
    // }

      // console.log(this.pageSize)
      // console.log(this.initialPageResetDone)
      // this.initialPageResetDone="search";
    //   if(this.initialPageResetDone=="search"){
    //   if(this.currentPage>0)
    //   {
    //     this.currentPage=0;
    //   }
    // }
      console.log(this.currentPage);
console.log(query)
console.log(this.faqpageSize)
// console.log(this.kbSearch)
// console.log(this.knowledgeSearchService.incidentmessage)
console.log(this.data)
console.log(this.initialPageResetDone)
// if(this.kbSearch || this.kbSearch==''||this.data==='script')
// {
// this.showlink=false;
// this.datatableload=false
// console.log("in kbsearch",this.kbSearch)
this.datatableload=false
if(query=='')
  {
    this.loadFAQs()
    if(this.currentPage>0)
    {
      this.currentPage=0;
    }
  }
  if(this.initialPageResetDone=="search"){
  if(this.currentPage>0)
  {
    this.currentPage=0;
  }
}

if (query !== '') {
  console.log("in second if")
  if((this.faqService.previousserchkeyword!=this.searchterms) && (this.searchterms!= undefined))
  {
 if(this.currentPage>0)
    {
      this.currentPage=0;
    }
    if(this.tabs.length>0)
    {
      this.tabs=[];
    }
  }

  const payload ={
    "entityName": "Searchcriteria",
    "payLoad": {
        "Searchcriteria.question": query,
    }
}
  forkJoin({
    searchResults: this.faqService.search(query, this.currentPage, this.faqpageSize),
    anotherData: this.faqService.entityCreate(payload),
  }).subscribe({
    next: (results) => {
      console.log(results);

      // Access the results of each service call
      this.allfaq = results.searchResults.answerlist;
      this.totalpagesize = results.searchResults.size;

      const anotherData = results.anotherData;
      console.log(anotherData);

      this.datatablepagination();
    },
    error: (err) => console.error('Error fetching data', err),
  });
}



// }

// else if(this.knowledgeSearchService.incidentmessage==="incident thread"){
// console.log("in kbsearch",this.kbSearch)
// console.log(query,this.currentPage,this.pageSize)
// this.datatableload=false
// this.knowledgeSearchService.getallcustomerfaq(query,this.currentPage,this.pageSize).subscribe((data:any)=>
// {
//   console.log(data);
//   // this.filteredResults=data;
//   this.allfaq=data.answerlist;
//   this.totalpagesize=data.size;


//   this.datatablepagination()
// })
// }


this.initialPageResetDone="search";
console.log(this.initialPageResetDone)

console.log(this.initialPageResetDone)
  }
  // faqForm: FormGroup
    onChangeSearch1(event:any) {
      this.faqtitle='Search Results';
                  localStorage.setItem('filter', "Search Results");

      console.log(this.faqtitle)

      // const searchterms=this.faqForm.value.name
      // $('.pane:visible .dt-search input').val(this.searchtermsinput).keyup();
      console.log(this.searchtermsinput)
      console.log(event)
      console.log(this.faqForm.value)
      console.log(this.keyword)
      console.log("onChangeSearch");
      if(event!=""){
          this.faqService.autoSuggestion(event).subscribe(data => {
            console.log(data)
              this.utilityService.setSearch(true);
              this.suggestionvalues = data;
              console.log(this.suggestionvalues);
              var keywordlist=[];
              for(let i=0;i<this.suggestionvalues.length;i++){
                keywordlist[i]=this.suggestionvalues[i].keywords.split(/[ ,]+/);
              //  this.autoFaqData[i].keywordsuggestion=keywordlist[i].toString();
              }
               console.log(keywordlist);
              for(let j=0;j<keywordlist.length;j++){
                for(let k=0;k<keywordlist[j].length;k++){
                  if(this.faqForm.value.name.replace(/[$&+, :;=?@#|'<>.^*()%!-]/g,'')==keywordlist[j][k])
                  {
                  console.log(keywordlist[j][k]);
                  var temp=keywordlist[j][k];
                  keywordlist[j][k]=keywordlist[j][0];
                  keywordlist[j][0]=temp;
                }
              }
            }
            for(let i=0;i<this.suggestionvalues.length;i++){
              // keywordlist[i]=this.autoFaqData[i].keywords.split(' ');
             this.suggestionvalues[i].keywords=keywordlist[i].slice(0,3).toString().replace('"', '');
            }
            this.datatablepagination();
            console.log(this.suggestionvalues)
             console.log(keywordlist);

          });
      }
      else{
          this.suggestionvalues=[];
          this.loadFAQs();
      }
  }

      suggestionvalues: any;
      // keyword = 'articletitle';
      Faqsearch() {
        this.getSelectedDetails();
        // this.faqtitle='Search Results';
        a = JSON.parse(localStorage.getItem('addtab')) || [];
        // console.log(this.faqForm.value.name);
        if (this.faqForm.value.name == null || this.faqForm.value.name == "") {
            localStorage.setItem("searchKeywords", "");
            localStorage.setItem('filter', "Search Results");
        } else {

            var a = [];
            var value = this.faqForm.value.name;
            if (typeof(value) == "object") {
                value = value.articletitle
            }

            localStorage.setItem("searchKeywords", value);
            localStorage.setItem('filter', "Search Results");
            this.local_filter="Search Results";
            if (this.local_filter == "Search Results")
            {
                 $(".table-block").removeClass("tableclass");
console.log("searchkeyword",localStorage.getItem("searchKeywords"))
console.log(this.faqForm.value)
                if(this.faqForm.value.name==""){
                  console.log("not in search")
                  this.loadFAQs()
                    // this.faqService.allArticles().subscribe((data) => {
                    //     this.populararticles = data;
                    //     this.dataSource.data = this.populararticles;
                    //     if(this.dataSource.data.length>=0){

                    //         this.check_data=true;
                    //     }
                    // });
                }
                else{
                  this.datatableload=false;
                  this.faqService.search(value,this.currentPage,this.faqpageSize).subscribe((data) => {
                    this.allfaq = data.answerlist;
                    console.log(this.allfaq)
              this.answerlistlength=data.answerlist.length;
                    this.totalpagesize=data.size;
                    console.log(this.allfaq);
                    this.datatablepagination()
                    this.suggestionvalues=[];
                  });
                }
        //     this.faqService.allArticles(this.currentPage,this.faqpageSize)
        //     .subscribe((data: any) => {
        //       console.log(data);
        //       this.allfaq = data.answerlist;
        //       console.log(this.allfaq)
        // this.answerlistlength=data.answerlist.length;
        //       this.totalpagesize=data.size;
        //       console.log(this.allfaq);
        //     });

        }
      }
        this.utilityService.setSearch(true);
        $("#all").prop('checked', false);
        $("#atoz").prop('checked', false);
        $("#popular").prop('checked', false);
console.log(this.local_filter)
        // this.componentSelectionEmitter({
        //     id: 'faq',
        //     name: 'FAQ',
        //     type: 'faq'
        // });
    }
    removeHtmlTags(value: string): string {
      if (!value) {
        return '';
      }
    
      // Remove escaped quotes and normal quotes
      value = value.replace(/\\"/g, '').replace(/"/g, '');
    
      // Convert HTML entities and remove HTML tags
      const div = document.createElement('div');
      div.innerHTML = value;
    
      let text = div.textContent || div.innerText || '';
    
      // Remove non-breaking spaces
      text = text.replace(/\u00A0/g, ' ');
    
      // Remove &nbsp; if it still exists
      text = text.replace(/&nbsp;/gi, ' ');
    
      // Remove extra spaces
      return text.replace(/\s+/g, ' ').trim();
    }
    emailValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const emailValue = control.value;
        if (emailValue && emailValue.trim() !== '') {
          const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

          return emailPattern.test(emailValue) ? null : { invalidEmail: true };
        }
        return null; // No email provided, no error
      };
    }
    // validateReasons() {
    //   const reasons = this.dislikeForm.get('reasons');
    //   return reasons.errors && reasons.errors.required;
    // }

    // Function to enable/disable submit button
    isSubmitDisabled() {
      return this.dislikeForm.invalid;
    }
    // onChange(id: string, isChecked: boolean) {
    //   const reasonsArray = this.dislikeForm.get('reasons') as FormArray;

    //   if (isChecked) {
    //     reasonsArray.push(new FormControl(id));
    //   } else {
    //     const index = reasonsArray.controls.findIndex(x => x.value === id);
    //     reasonsArray.removeAt(index);
    //   }
    // }

    // reset() {
    //   this.dislikeForm.reset();
    // }
      // dataSource = new MatTableDataSource(this.populararticles);
      // noData = this.dataSource.connect().pipe(map((data:any) => data.length === 0));
    ngOnInit() {
      this.suggestionvalues=''
      // $(document).on('click', '.cat-b b', function () {});

      $(document).ready(function() {
        $(".toggle-filter .filter-btn").click(function() {
          $(".toggle-filter .filter-btn").removeClass('active');
          $(this).addClass('active');
        });
      });



      this.faqForm = this.formBuilder.group({
        name: ['', Validators.required],
    });


      // this.loadFAQs();
      // this.getallpopularanswers();
      this.dataSource = new MatTableDataSource(this.populararticles);
      this.noData = this.dataSource.connect().pipe(map((data:any) => data.length === 0));


      console.log("in faq")
        console.log('a-z ', this.azid)
        if(this.azid) {
            this.utilityService.getAtoZCount().subscribe(data => {
                if(JSON.stringify(data) != "{}") {
                    this.createSequence(data);
                }
            });
        }
        this.setReason();
        // this.addResons();
        this.utilityService.getUser().subscribe((data: any) => {
            console.log(data);
            this.user = data;
            this.toEmails=( this.user)? this.user.email:'';
        });
        this.dislikeForm = this.formBuilder.group({
            firstName: [''],
            lastName: [''],
            email: ['', [Validators.required,this.emailValidator()]],
            comment: [''],
            notifyme: [''],
            phone: ['', [Validators.required,Validators.minLength(14) ]],
            reason: this.formBuilder.array([],Validators.required),
        });
        this.dislikeFormArray = this.dislikeForm.get('reason') as FormArray;
        // for(let i in this.reason_array) {
        //     this.dislikeFormArray.push(new FormControl(this.reason_array[i],  Validators.required));
        // }
        // console.log(this.dislikeFormArray);

        this.emailFormData = this.formBuilder.group({
            toaddr: ['', Validators.required],
            ccaddr:[''],
            subject: ['', Validators.required],
            emailmsg: ['', Validators.required]
        });
        this.emailFormData.patchValue({
            toaddr: this.toEmails,
            //emailmsg: this.emailContent
        });

        // Call Data based on filter
        this.local_filter = localStorage.getItem("filter") || "";
        if(this.selectionType == "help" || this.selectionType == "training") {
            localStorage.setItem("filter","Popular");
            this.local_filter=localStorage.getItem("filter") || "";
            this.faqtitle = localStorage.getItem("filter");
            this.utilityService.setSearch(false);
        } else {
            this.utilityService.getSearch().subscribe(data => {
                if(data == false) {
                    localStorage.setItem('addtab', JSON.stringify([]));
                    // this.utilityService.setSearch(false);
                }
            });
            // localStorage.setItem('addtab', JSON.stringify([]))
        }

        if(this.local_filter==""){
            localStorage.setItem("filter","Search Results");
            localStorage.setItem("searchKeywords","")
            this.local_filter=localStorage.getItem("filter") || "";
            this.faqtitle = localStorage.getItem("filter");
        }
        this.classname = "clicked5";


        if (this.local_filter == "Search Results")
        {
             $(".table-block").removeClass("tableclass");
            if(localStorage.getItem("searchKeywords") == null || localStorage.getItem("searchKeywords") == ""){
              console.log("not in search")
              this.loadFAQs()
                // this.faqService.allArticles().subscribe((data) => {
                //     this.populararticles = data;
                //     this.dataSource.data = this.populararticles;
                //     if(this.dataSource.data.length>=0){

                //         this.check_data=true;
                //     }
                // });
            }
            else{
              this.datatableload=false;
              console.log("in search")
              console.log(this.currentPage,this.faqpageSize)
                this.faqService.search(localStorage.getItem("searchKeywords"),this.currentPage,this.faqpageSize).subscribe((data) => {
                  this.allfaq = data.answerlist;
                  console.log(this.allfaq)
            this.answerlistlength=data.answerlist.length;
                  this.totalpagesize=data.size;
                  console.log(this.allfaq);

                  this.datatablepagination()
                });
            }
            this.getSelectedDetails();
            this.tabs = JSON.parse(localStorage.getItem('addtab')) || [];
        }

        if (this.local_filter == "All") {
          console.log("all faq")
             $(".table-block").removeClass("tableclass");
             this.loadFAQs();
            // this.faqService.allArticles(this.currentPage,this.pageSize).subscribe((data) => {
            //   console.log(data)
            //     this.populararticles = data.answerlist;
            //     this.answerlistlength=data.answerlist.length;
            //     this.totalpagesize=data.size;
            //     // console.log(this.populararticles)
            //     // this.currentPage,this.pageSize

            //     // console.log(this.dataSource.data)

            //     // this.dataSource = new MatTableDataSource(this.populararticles);
            //     // // this.dataSource.data=this.dataSource;
            //     // this.dataSource._data._value=this.dataSource;
            //     // console.log(this.dataSource.data)
            //     // console.log(this.dataSource._data._value.filteredData)
            //     // this.alldata=this.dataSource._data._value.filteredData;
            //     // console.log(this.dataSource)
            //     // if(this.dataSource.data.length>=0){
            //     //     this.check_data=true;

            //     // }
            // });
            this.getSelectedDetails()
            this.tabs = JSON.parse(localStorage.getItem('addtab')) || [];
            console.log("hello tab",this.tabs)
        }
        if (this.local_filter == "A-Z") {
            $(".table-block").addClass("tableclass");
            this.loadFAQs();
            // this.faqService.allArticles().subscribe((data) => {
            //     this.populararticles = data;
            //     this.dataSource.data = this.populararticles;
            //     if(this.dataSource.data.length>=0){
            //         this.check_data=true;
            //     }

            // });
// this.loadFAQs();
            this.getSelectedDetails()

            this.tabs = JSON.parse(localStorage.getItem('addtab')) || [];
        }
        if (this.local_filter == "Popular") {
            console.log('In popular');
             $(".table-block").removeClass("tableclass");
            localStorage.removeItem('remove');
            // console.log(this.currentPage)
            // console.log(this.faqpageSize)
            this.getallpopularanswers();
            this.getSelectedDetails()
            this.tabs = JSON.parse(localStorage.getItem('addtab')) || [];
        }
        if (localStorage.getItem("filter") == "Recent") {
            localStorage.removeItem('remove');
             $(".table-block").removeClass("tableclass");
             this.local_filter="Recent";
        this.getrecentfaq();
            this.getSelectedDetails()
            this.tabs = JSON.parse(localStorage.getItem('addtab')) || [];
        }
        // this.tabs = this.tabs.slice(1, this.tabs.length);
        if(this.selectionType == "help") {
            this.tabs = [];
            // localStorage.setItem("addtab", this.tabs);
            localStorage.setItem("filter", "Popular");
            this.azid = false;
           this. getDetailsByArticleID(11);
           this.utilityService.setVisited(true);
        } else if(this.selectionType == "training") {
            this.tabs = [];
            // localStorage.setItem("addtab", this.tabs);
            localStorage.setItem("filter", "Popular");
            this.azid = false;
            this. getDetailsByArticleID(12);
            this.utilityService.setVisited(true);
        } else {
            this.utilityService.isVisited().subscribe(data => {
                if(data == true) {
                    this.tabs = [];
                    // localStorage.setItem("addtab", this.tabs);
                    this.utilityService.setVisited(false);
                }
            });
            // this.tabs = [];
        }
        console.log(JSON.parse(localStorage.getItem('addtab')));
        console.log('tabs ', this.tabs);
    }
    clickget()
    {
        $(".cdk-overlay-connected-position-bounding-box").addClass("tablepagination");
        if(localStorage.getItem("filter") == "A-Z")
        {
            $(".cdk-overlay-container").addClass("newclass");

        }
        else
        {
            $(".cdk-overlay-container").removeClass("newclass");
        }
        if(this.classname=="clicked5")
        {
            $(".cdk-overlay-container").addClass("clicked5class");
        }
    }
    get f() {
        return this.dislikeForm.controls;
    }
    get reasons() {
        return this.dislikeForm.get('reason') as FormArray;
    }
    addResons() {
        // this.dislikeForm.controls['reason'].setValue([]);
        // console.log(this.dislikeForm.controls['reason']);

        for(let i in this.reason_array) {
            this.reasons.removeAt(parseInt(i));
            this.reasons.push(this.formBuilder.control(this.reason_array[i]));
        }
        console.log(this.dislikeForm.get('reason'))
        console.log(this.reasons);
    }

    printPage() {
window.print();
    }
    // @ViewChild('pdfTable', {static: false}) pdfTable: ElementRef;


    // public SavePDF(): void {
    //   let content=this.content.nativeElement;
    //   let doc = new jsPDF();
    //   let _elementHandlers =
    //   {
    //     '#editor':function(element,renderer){
    //       return true;
    //     }
    //   };
    //   doc.fromHTML(content.innerHTML,15,15,{

    //     'width':190,
    //     'elementHandlers':_elementHandlers
    //   });

    //   doc.save('test.pdf');
    // }


    positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
    position = new FormControl(this.positionOptions[0]);


    // ------------------------------------------

    // email form
    get eform() {
        return this.emailFormData.controls;
    }

    reasonArray() {
                this.reason_array = [{
                    id: "1",
                    name: "Incorrect Information",
                    checked: false,
                    control: "incorrect"
                },
                {
                    id: "2",
                    name: "Irrelevant Information",
                    checked: false,
                    control: "irrelevant"
                },
                {
                    id: "3",
                    name: "Duplicate Information",
                    checked: false,
                    control: "duplicate"
                },
                {
                    id: "4",
                    name: "Outdated Information",
                    checked: false,
                    control: "outdated"
                },
                {
                    id: "5",
                    name: "Other",
                    checked: false,
                    control: "other"
                }
                ];
    }

    // create reasons array
    setReason() {
        $(".sidenav-link").removeClass("active");
        $("#sub_menu_sidenav_bar").addClass("open");
        if(this.selectionType == "help") {
            $("#help-tab").addClass("active");
        } else if(this.selectionType=="training") {
            $("#training-tab").addClass("active");
        } else if(this.selectionType=="faq"){
            $("#faq-tab").addClass("active");
        }

        // this.componentSelectionEmitter({
        //     id: 'faq',
        //     name: 'FAQ',
        //     type: 'faq'
        // });
       this.reasonArray();
    }

    // create 0-9 and alphabets
    createSequence(data){
        console.log('In createSeq ', data);
        //loop through the values from i to j
        this.keytabs = [];
        this.keytabs.push({ keywords:'0-9', count: data['0-9'], disabled: data['0-9'] == 0});
        for(var k = this.start; k < this.end; k++){
            //convert the char code to string (Alphabets)
            var str =String.fromCharCode(k);
            var char = str.toString().toLowerCase();
            this.keytabs.push({ keywords:str, count: data[char], disabled: data[char] == 0});
        }
        console.log(this.keytabs);
    }

    //Get name of the file
    getArticleFileName(file) {
        // this.fileName = file.substring(file.lastIndexOf('/') + 1);
        console.log(this.cardDetails);
        console.log(this.cardDetails.description);
        this.emailFormData.patchValue({
            subject: this.cardDetails.ansid + ": " + this.cardDetails.answeridobject.description.replace(/<p>|<\/p>|"/g, '')
        });
    }
    dislikeClick() {
        console.log(this.cardDetails);
        this.submitted = false;

        // this.getDetailsByArticleID(this.cardDetails.id);
        // setTimeout(() => {
            if(this.like) {
                this.reasonArray();
                this.clearFormArray(this.dislikeFormArray);
                // this.dislikeReasons = this.cardDetails.likeStatus.options;
               console.log(this.cardDetails.likeStatus.options);
                for(let i in this.cardDetails.likeStatus.options) {
                    console.log(this.cardDetails.likeStatus.options[i]-1);
                    this.required = false;
                    this.reason_array[this.cardDetails.likeStatus.options[i]-1].checked = true;
                }
                // this.dislikeForm.patchValue({
                //     firstName: this.user.firstname,
                //     lastName: this.user.lastname,
                //     email: this.user.email
                // });
                this.dislikeForm.patchValue({
                    firstName: this.cardDetails.likeStatus && this.cardDetails.likeStatus.firstname!=null ? this.cardDetails.likeStatus.firstname: this.user.firstname,
                    lastName: this.cardDetails.likeStatus && this.cardDetails.likeStatus.lastname!=null? this.cardDetails.likeStatus.lastname: this.user.lastname,
                    email: this.cardDetails.likeStatus && this.cardDetails.likeStatus.email!=null? this.cardDetails.likeStatus.email: this.user.email,
                    // reason:  this.cardDetails.likeStatus.options,
                    comment: this.cardDetails.likeStatus?this.cardDetails.likeStatus.comments:'',
                    notifyme: this.cardDetails.likeStatus?this.cardDetails.likeStatus.notifyme:'',
                    phone: this.cardDetails.likeStatus?this.cardDetails.likeStatus.phone:''
                });
            }
            else {
                if( this.cardDetails.likeStatus) {
                    this.reasonArray();
                    this.clearFormArray(this.dislikeFormArray);
                    // this.dislikeReasons = this.cardDetails.likeStatus.options;
                   console.log(this.cardDetails.likeStatus.options);
                    for(let i in this.cardDetails.likeStatus.options) {
                        console.log(this.cardDetails.likeStatus.options[i]-1);
                        this.required = false;
                        this.reason_array[this.cardDetails.likeStatus.options[i]-1].checked = true;
                        this.dislikeFormArray.push(new FormControl(this.cardDetails.likeStatus.options[i]));
                    }
                    if(this.cardDetails.likeStatus.flike) {
                        this.like=true;
                        this.dislike = false;
                    } else {
                        this.dislike=true;
                        this.like = false;
                    }
                }
                    console.log(this.reason_array);
                    this.dislikeForm.patchValue({
                        firstName: this.cardDetails.likeStatus && this.cardDetails.likeStatus.firstname!=null ? this.cardDetails.likeStatus.firstname: this.user.firstname,
                        lastName: this.cardDetails.likeStatus && this.cardDetails.likeStatus.lastname!=null? this.cardDetails.likeStatus.lastname: this.user.lastname,
                        email: this.cardDetails.likeStatus && this.cardDetails.likeStatus.email!=null? this.cardDetails.likeStatus.email: this.user.email,
                        // reason:  this.cardDetails.likeStatus.options,
                        comment: this.cardDetails.likeStatus?this.cardDetails.likeStatus.comments:'',
                        notifyme: this.cardDetails.likeStatus?this.cardDetails.likeStatus.notifyme:'',
                        phone: this.cardDetails.likeStatus?this.cardDetails.likeStatus.phone:''
                    });
            }
        // }, 100);
    }
    // On like button click
    likeClick() {

      // console.log(this.answerbyid.likestatus.flike)
      if(this.like==false)
        {


console.log(this.cardDetails)
console.log(this.answerbyid.likestatus)

       this.likePayload.answerid=this.cardDetails.id;
        // this.likePayload.commentby = "";
        // this.likePayload.commentdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        this.likePayload.flike = true;
        console.log(this.likePayload.flike)
        // this.likePayload.id = this.cardDetails.likeStatus != null ? this.cardDetails.likeStatus.id : '';
console.log(this.likePayload)
console.log(this.answerbyid.likestatus)
        // this.likePayload.userId = 1;

            this.faqService.likeArticle(this.likePayload).subscribe((data: any) => {
            console.log(data);
            if (data != null && data == true) {
              console.log("in like")
              this.answerbyid.likestatus = data;
                this.dislike=false;
                console.log(this.dislike)
                this.like=true;
                this.resetUnlikeForm();
                console.log(this.user.firstname)
                this.required = true;
                this.dislikeForm.patchValue({
                    firstName: this.user.firstname,
                    lastName: this.user.lastname,
                    email: this.user.email,
                });
                // setTimeout(function() {
                //     $(".faq-desc").trigger("click");
                // }, 3000);
            }
        });
      }

    }
    // dislikeClick() {

    // }

    // On reason checkbox change
    onChange(reason: string, isChecked: boolean) {
        // const reasonFormArray = < FormArray > this.dislikeForm.controls.reason;

        // if(isChecked) {
        //     reasonFormArray.push(new FormControl(reason));
        // } else {
        //     let index = reasonFormArray.controls.findIndex(x => x.value == reason)
        //     reasonFormArray.removeAt(index);
        // }
        // console.log(this.dislikeFormArray);
        // reasonFormArray.value.length == 0 ? this.required = true : this.required = false;

        if(isChecked) {
            this.dislikeFormArray.push(new FormControl(parseInt(reason)));
        } else {
            let index = this.dislikeFormArray.controls.findIndex(x => x.value == reason)
            this.dislikeFormArray.removeAt(index);
        }
        console.log(this.dislikeFormArray);
        console.log(this.dislikeForm.value);
        this.dislikeFormArray.value.length == 0 ? this.required = true : this.required = false;
    }

    // On dislike submit click
    onSubmit() {
      this.submitted = true;
      if(this.dislikeForm.invalid) {
        return; // Prevent submission
      }
      else if(this.dislikeForm.valid) {
        // this.utilityService.checkLogin();
console.log("in onsubmit")
        this.submitted = true;
        if (this.dislikeForm.value.notifyme) {
          this.dislikeForm.controls['email'].setValidators([Validators.required, this.emailValidator()]);
          this.dislikeForm.controls['email'].updateValueAndValidity();
      } else {
          this.dislikeForm.controls['email'].setValidators([this.emailValidator()]);
          this.dislikeForm.controls['email'].updateValueAndValidity();
      }
        if (this.dislikeForm.invalid || this.required) {
            return;
        }
        this.dislikePayload.answerid = this.cardDetails.id;
        console.log(this.dislikePayload.answerid)
        // this.dislikePayload.commentby = this.user.lastname;
        this.dislikePayload.commentdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        this.dislikePayload.comments = this.dislikeForm.value.comment;

        this.dislikePayload.firstname = this.dislikeForm.value.firstName;
        this.dislikePayload.lastname = this.dislikeForm.value.lastName;
        this.dislikePayload.phone = this.dislikeForm.value.phone;
        this.dislikePayload.email = this.dislikeForm.value.email;
        this.dislikePayload.notifyme = this.dislikeForm.value.notifyme;
        this.dislikePayload.flike = false;
        // this.dislikePayload.id = this.cardDetails.likeStatus != null ? this.cardDetails.likeStatus.id : '';

        this.dislikePayload.options = this.dislikeForm.value.reason;
        console.log('dislike payload ', this.dislikePayload);

        this.faqService.dislikeArticle(this.dislikePayload).subscribe((data: any) => {
            console.log(data);
            if (data!=null) {
                this.dislike=true;
                this.like=false;
                this.cardDetails.likeStatus = data;
                if(data.likeStatus) {
                    this.reasonArray();
                    this.clearFormArray(this.dislikeFormArray);
                    console.log(this.dislikeFormArray);
                    for(let i in data.likeStatus.options) {
                        console.log('inside for');
                        this.required = false;
                        this.reason_array[data.likeStatus.options[i]-1].checked = true;
                        this.dislikeFormArray.push(new FormControl(this.cardDetails.likeStatus.options[i]));
                    }
                }
                console.log(this.reason_array);
                this.dislikeForm.patchValue({
                    firstName: data.likeStatus? data.likeStatus.firstname: this.user.firstname,
                    lastName: data.likeStatus? data.likeStatus.lastname: this.user.lastname,
                    email: data.likeStatus? data.likeStatus.email: this.user.email,
                    // reason:  this.cardDetails.likeStatus.options,
                    comment: data.likeStatus?data.likeStatus.comments:'',
                    notifyme: data.likeStatus?data.likeStatus.notifyme:'',
                    phone: data.likeStatus?data.likeStatus.phone:''
                });
                this.getDetailsByArticleID(this.cardDetails.id);
                $("#dislikeModal"+this.selectionType + " .close").trigger("click");
                $("#dislike_thanks"+this.selectionType).trigger("click");

                this.resetUnlikeForm();

                setTimeout(function() {
                    $("#dislikeSentModal .close").trigger("click");
                }, 500);
            }
        });
      }
    }
    reset() {
        // this.dislikeReasons = [];
        this.required = true;
        this.resetUnlikeForm();
    }
    // Reset unlike form
    resetUnlikeForm(){
        this.reason_array = [];
        this.setReason();
        this.submitted = false;
        this.dislikeForm.reset();
        this.dislikeForm.controls['email'].setValidators([Validators.required, this.emailValidator()]);
        this.dislikeForm.controls['email'].updateValueAndValidity();

        this.dislikeForm.controls['phone'].setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(14)]);
        this.dislikeForm.controls['phone'].updateValueAndValidity();

        this.dislikeForm.get('reason').setValidators(Validators.required);
        this.dislikeForm.get('reason').updateValueAndValidity();
        // for(let i in data.likeStatus.options) {
        //     console.log('inside for');
        //     this.required = false;
        //     this.reason_array[data.likeStatus.options[i]-1].checked = true;
        // }
        const control = < FormArray > this.dislikeForm.controls['reason'];
        for (let i = control.length - 1; i >= 0; i--) {
            control.removeAt(i)
        }
    }

    // Send Email
    sendArticleEmail() {
        this.emailFormSubmitted = true;
        // this.utilityService.checkLogin();
console.log(this.cardDetails.answeridobject.solution);
        if (this.emailFormData.value.toaddr!=null) {
          console.log("in email")

            this.emailFormData.controls['toaddr'].setValidators([Validators.required,this.commaSepEmail]);
            this.emailFormData.controls['toaddr'].updateValueAndValidity();
         }
         console.log(this.emailFormData.value.toaddr)

        if (this.emailFormData.invalid) {
            return;
        }

        console.log(this.cardDetails)
        console.log( this.emailFormData);
           // "body_html": "<p>Testing by sandeep</p>",
        // "to": [
        //   "sandeep.janumpally@nebulogic.com"
        // ],
        // "cc": [],
        // "subject": "Testing from CRM"
        //  }
        this.sendMailData.to = []; // Initialize it as an empty array
        this.sendMailData.to.push(this.emailFormData.value.toaddr);
        console.log()
        console.log( this.sendMailData.to.push(this.emailFormData.value.toaddr))
        this.sendMailData.to = [this.emailFormData.value.toaddr];
        this.sendMailData.cc=[this.emailFormData.value.ccaddr];
        this.sendMailData.subject = this.emailFormData.value.subject;
        this.sendMailData.body_html = this.cardDetails.answeridobject.solution;

        // this.sendMailData.templateName = "sharearticle";
        // this.sendMailDataPayload.articleID = this.cardDetails.id;
        // this.sendMailDataPayload.article = this.cardDetails.articledescriptionshort;
        // this.sendMailDataPayload.body_html = this.emailFormData.value.emailmsg;
        // this.sendMailData.payload = this.sendMailDataPayload;
        // this.sendMailData.attachmenturl = this.cardDetails.pdfurl.toString().trim();

        // this.sendMailData={
        //   "to":"pradeep.ciriguri@nebulogic.com,arunkanth.sunkara@nebulogic.com",
        //   "subject":"Sample Test",
        //   "templateName":"sharearticle",
        //   "payload":
        //       {
        //       "articleID": "RE001",
        //       "article": "How do I register for an account?",
        //       "shortdesc": "New Maine SMART CHSTS Portal users must send an email to the respective Maine CDC contact for new user registration.\n\n\n\nFor questions about newborn bloodspot, contact Anne Watson. Email: anne.watson@maine.gov, Ph: (207) 287-8188 \nFor questions about newborn hearing and/or audiology, contact Anne Banger. Email: anne.banger@maine.gov, Ph: (207)287-8427\nFor questions about birth defects, contact Anna Cyr. Email: anna.cyr@maine.gov, Ph: (207) 287-8424\n\n\nAfter the user has been restored within the portal, you will receive an email from support.mainechsts@nebulogic.com with login credentials and password reset information.\n"
        //    },
        //    "attachementurl":"https://nebulogic.com/old/NebuLogic-Corporate-Brochure.pdf"
        // };


        console.log(this.sendMailData);
        this.faqService.sendEmailAttachment(this.sendMailData).subscribe(data => {
           // if (data == true) {
                var stringValue = data.toString();
                this.emailtexttoggle=JSON.parse(stringValue);
                $("#emailModal"+this.selectionType +" .close").trigger("click");
                $("#triggeremail"+this.selectionType).trigger("click");
            //}
        });
    }
    incrementZoom() {
        if(this.toggle)
        {
            this.toggle=false;
            document.getElementById('pdfZoomModal'+this.selectionType).style.maxWidth ='37%';
        }
        else{
            this.toggle=true;
            document.getElementById('pdfZoomModal'+this.selectionType).style.maxWidth ='81.6%';
        }
    }
    pdfExpand() {
        if (this.toggle) {
            this.toggle = false;
            document.getElementById('pdfZoomModal'+this.selectionType).style.maxWidth = '37%';
        }
    }
    getTrimmedContent(text: string): string {
      if (!text) {
        return '';
      }
      const maxLength = 200;
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    }
    //-------------------------------------
}
